import script from "./ProductBorder.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductBorder.vue?vue&type=script&setup=true&lang=js"

import "./ProductBorder.vue?vue&type=style&index=0&id=8637302e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8637302e"]])

export default __exports__